// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .credits {
  display: flex;
  align-items: center;
  background-color: white;
  color: #000;
}
.theme-light .credits .totalCredits {
  border-radius: 50%;
  padding: 5px;
  background-color: red;
  color: white;
}
.theme-dark .credits {
  display: flex;
  align-items: center;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .credits .totalCredits {
  border-radius: 50%;
  padding: 5px;
  background-color: red;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/credits/credits.scss"],"names":[],"mappings":"AAqBI;ECjBA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAFJ;AAGI;EACI,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AADR;ADUI;ECjBA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAUJ;AATI;EACI,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AAWR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.credits {\n  @include themify($themes) {\n    display: flex;\n    align-items: center;\n    background-color: themed(\"bg\");\n    color: themed(\"textColor\");\n    .totalCredits {\n        border-radius: 50%;\n        padding: 5px;\n        background-color: red;\n        color: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
